/* eslint-disable @typescript-eslint/naming-convention */
import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import { getVerbalColors } from 'helpers'
import { useThemeContext } from 'providers'

const jss = (t) => {
    return {
        barsContainer: {
            display: 'flex',
            gap: '11px'
        },
        bar: {
            borderWidth: '3px',
            borderStyle: 'solid',
            borderRadius: '3px',
            transition: 'border-color 0.3s ease-in-out'
        }
    }
}

const useStyles = makeStyles(jss)

interface PropsInterface {
    total: number,
    completed: number,
    color?: string,
    className?: string
}

/**
 *
 */
const PasswordStrengthBar = ({ total, completed, className = '' }: PropsInterface): JSX.Element => {
    // total = 5
    const styles = useStyles()
    const themeContext = useThemeContext()
    const verbalColors = useMemo(() => {
        const { colors } = themeContext?.['foundations-library'] ?? {}
        return getVerbalColors(colors)
    }, [])

    const color = useMemo(() => {
        const percentageCompleted = (completed / total) * 100

        if (percentageCompleted <= 40) {
            return verbalColors['destructive-400']
        }

        if (percentageCompleted <= 80) {
            return '#FD9A27'
        }

        return verbalColors['primary-500']
    }, [completed, total])

    return <div className={`${styles.barsContainer} ${className}`}>
        {Array.from({ length: total }, (_, index) => (
            <div
                key={index}
                className={styles.bar}
                style={{
                    width: `${100 / total}%`,
                    borderColor: index < completed ? color : verbalColors['neutral-50']
                }}
                data-testid={`bar-${index + 1}`}
            />
        ))}
    </div>
}

export default PasswordStrengthBar
